var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 24.4754C13 24.4754 11.1125 23.7004 9.7 22.2879C8.99907 21.5927 8.44356 20.7649 8.06584 19.8528C7.68813 18.9408 7.49578 17.9626 7.5 16.9754C7.5 15.0004 8.275 13.0879 9.7 11.6754L15 6.37539M22.075 9.91289L15 2.83789L7.925 9.91289C4.025 13.8129 4.025 20.1504 7.925 24.0504C8.85356 24.9798 9.95657 25.7167 11.1707 26.2187C12.3849 26.7206 13.6862 26.9778 15 26.9754C17.5625 26.9754 20.125 26.0004 22.075 24.0504C25.975 20.1504 25.975 13.8129 22.075 9.91289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.e2c3268fa8bcbfc51e84e16fb348c760.svg";
export { ForwardRef as ReactComponent };